export default {
  subheading: 'Make your own order',
  addCategory: 'Select',
  addSubcategory: 'Add to your order',
  step1: 'Step 1',
  step1Description: 'Select a product category',
  step2: 'Step 2',
  step2Description: 'Select a type of repackaging',
  step3: 'Step 3',
  step3Description: 'Configure the product as you wish',
  step4: '<b>Step 4</b> (optional)',
  step4Description: 'Choose a package add-on (add-ons are provided by a client)',
  novelty: 'New',
  checkPrice: 'Show approximate order price',
  noBonus: 'No add-ons',
  flavorsLeft: 'Flavors left',
  maximum: 'a maximum of',
  inPackage: 'in a package',
  anyConfig: 'flavors in any configuration',
  close: 'Close',
  expand: 'Expand',
  numberError: 'Select the maximum number of products',
};
